import A1 from "modules/ebiForms/definitions/A1";
import A3 from "modules/ebiForms/definitions/A3";
import A5 from "modules/ebiForms/definitions/A5";
import A6 from "modules/ebiForms/definitions/A6";
import A7 from "modules/ebiForms/definitions/A7";
import A8 from "modules/ebiForms/definitions/A8";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** Planowanie, nieruchomości i podatki lokalne: A1, A3, A5, A6, A7, A8 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [A1, A3, A5, A6, A7, A8];

export default FORMS;
